export default {
  'media.title': 'Media &',
  'media.titleHighlight': 'Links',
  'media.subtitle': '研究成果やプロジェクト、メディアへのリンク',
  'media.projectsTitle': 'Projects & Media',
  'media.socialTitle': 'Social Media',
  'media.showMore': 'もっと見る ({count}件のメディア)',
  'media.cta.title': '共同研究・開発のご相談',
  'media.cta.description': '大学・業界とらわれず、さまざまな方と共同研究や開発などを積極的に進めて行こうと思っています。ぜひお気軽にお声がけください。',
  'media.cta.button': 'お問い合わせ',

  // Social Media
  'media.social.linkedin.desc': 'プロフェッショナルなネットワーキング',
  'media.social.twitter.desc': '研究や技術に関する情報発信',
  'media.social.email.desc': '直接のお問い合わせ',
};
